module.exports = __webpack_public_path__ + "static/media/wasteManagement.bb1c989b.png";